import React from "react"

import { Flex, BoxProps } from "components/box"

import AddYellow from "assets/icons/addYellow.svg"
import Acute from "assets/icons/product-categories/acute.svg"
import Adjust from "assets/icons/adjust.svg"
import ArrowLeft from "assets/icons/arrow-left.svg"
import ArrowRight from "assets/icons/arrow-right.svg"
import ArrowDown from "assets/icons/arrow-down.svg"
import All from "assets/icons/product-categories/all.svg"
import Avatar from "assets/icons/avatar.svg"
import Caret from "assets/icons/caret.svg"
import CheckMark from "assets/icons/check-mark.svg"
import Cross from "assets/icons/cross.svg"
import Doctor from "assets/icons/doctor.svg"
import Error from "assets/icons/error.svg"
import Logo from "assets/icons/logo.svg"
import Nausea from "assets/icons/product-categories/anti-nausea.svg"
import Pill from "assets/icons/pill.svg"
import Prevent from "assets/icons/product-categories/preventative.svg"
import Supplement from "assets/icons/product-categories/supplement.svg"
import Stethoscope from "assets/icons/stethoscope.svg"
import BackArrow from "assets/icons/back-arrow.svg"
import HamburgerMenu from "assets/icons/hamburger-menu.svg"
import CoveLogo from "assets/icons/cove-logo.svg"
import CoveChair from "assets/icons/cove-chair.svg"
import Message from "assets/icons/message.svg"
import Plus from "assets/icons/plus.svg"
import NeedsRx from "assets/icons/needs-rx.svg"
import MigraineTracker from "assets/icons/migraine-tracker.svg"
import CoveChairTransparent from "assets/icons/cove-chair-transparent.svg"
import Instagram from "assets/icons/instagram.svg"
import Facebook from "assets/icons/facebook.svg"
import Twitter from "assets/icons/twitter.svg"
import Linkedin from "assets/icons/linkedin.svg"
import Star from "assets/icons/star.svg"
import Previous from "assets/icons/previous.svg"
import Next from "assets/icons/next.svg"
import PaperPlane from "assets/icons/paper-plane.svg"
import Search from "assets/icons/search.svg"

import OrderConsult from "assets/icons/order-icons/icon-doctor.svg"
import OrderSupport from "assets/icons/order-icons/icon-support.svg"
import OrderPill from "assets/icons/order-icons/icon-pill.svg"
import OrderDrug from "assets/icons/order-icons/icon-drug.svg"

// Icons for the PDP Page
import AffordableCoin from "assets/icons/pdp/benefits/affordable-coin.svg"
import DoctorStethescope from "assets/icons/pdp/benefits/doctor-stethescope.svg"
import ShippingTruck from "assets/icons/pdp/benefits/shipping-truck.svg"

import ChooseFinger from "assets/icons/pdp/how-cove-works/choose-plan-finger.svg"
import ConsultationPencil from "assets/icons/pdp/how-cove-works/consultation-pencil.svg"
import DeliveryHouse from "assets/icons/pdp/how-cove-works/delivery-house.svg"

import DosageDropper from "assets/icons/pdp/product-details/dosage-dropper.svg"
import FormPill from "assets/icons/pdp/product-details/form-pill.svg"
import HowToTakeFace from "assets/icons/pdp/product-details/how-to-take-face.svg"
import NameMolecule from "assets/icons/pdp/product-details/name-molecule.svg"
import ServingsBottle from "assets/icons/pdp/product-details/servings-bottle.svg"
import TypeMill from "assets/icons/pdp/product-details/type-mill.svg"

import ReviewsChat from "assets/icons/pdp/reviews-chat.svg"

// Icons for the Renewal Flow
import FrequencyIcon from "assets/icons/renewal-flow/frequency-icon.svg"
import RenewalCheckmark from "assets/icons/renewal-flow/checkmark.svg"

import Approved from "assets/icons/approved.svg"
import Matched from "assets/icons/matched.svg"

import Treatment from "assets/icons/blob-icons/treatment.svg"
import AccessDr from "assets/icons/blob-icons/access-dr.svg"
import Tracker from "assets/icons/blob-icons/tracker.svg"
import StartQuote from "assets/icons/start-quote.svg"
import EndQuote from "assets/icons/end-quote.svg"

import Overlay1 from "assets/icons/overlays/overlay-1.svg"
import Overlay2 from "assets/icons/overlays/overlay-2.svg"
import Overlay3 from "assets/icons/overlays/overlay-3.svg"

import LineLeft from "assets/icons/marketing/line-left.svg"
import LineRight from "assets/icons/marketing/line-right.svg"

// Homepage
import TreatmentPlan from "assets/icons/blob-icons/treatment-plan.svg"
import Affordable from "assets/icons/blob-icons/affordable.svg"
import Home from "assets/icons/blob-icons/home.svg"
import Journey from "assets/icons/blob-icons/journey.svg"
import DoctorB from "assets/icons/blob-icons/doctor.svg"
import Announce from "assets/icons/blob-icons/announce.svg"

import Overlay4 from "assets/icons/overlays/overlay-4.svg"
import Overlay5 from "assets/icons/overlays/overlay-5.svg"
import Overlay6 from "assets/icons/overlays/overlay-6.svg"
import Overlay7 from "assets/icons/overlays/overlay-7.svg"
import Overlay8 from "assets/icons/overlays/overlay-8.svg"
import Overlay9 from "assets/icons/overlays/overlay-9.svg"

// Our offerring
import RxIconLarge from "assets/icons/our-offering/rx-icon-large.svg"
import RxIconSmall from "assets/icons/our-offering/rx-icon-small.svg"
import NewBadge from "assets/icons/our-offering/new-badge.svg"

export type IconName =
  | "acute"
  | "adjust"
  | "addYellow"
  | "antiNausea"
  | "arrowLeft"
  | "arrowRight"
  | "arrowDown"
  | "all"
  | "avatar"
  | "caret"
  | "checkMark"
  | "coveLogo"
  | "cross"
  | "doctor"
  | "error"
  | "logo"
  | "pill"
  | "preventative"
  | "supplement"
  | "stethoscope"
  | "hamburgerMenu"
  | "orderConsult"
  | "orderSupport"
  | "orderPill"
  | "orderDrug"
  | "backArrow"
  | "coveChair"
  | "message"
  | "plus"
  | "needsRx"
  | "migraineTracker"
  | "coveChairTransparent"
  | "instagram"
  | "facebook"
  | "twitter"
  | "linkedin"
  | "affordableCoin"
  | "doctorStethescope"
  | "shippingTruck"
  | "chooseFinger"
  | "consultationPencil"
  | "deliveryHouse"
  | "dosageDropper"
  | "formPill"
  | "howToTakeFace"
  | "nameMolecule"
  | "servingsBottle"
  | "typeMill"
  | "reviewsChat"
  | "frequency"
  | "renewalCheckmark"
  | "star"
  | "previous"
  | "next"
  | "search"
  | "approved"
  | "matched"
  | "drAccess"
  | "tracker"
  | "treatment"
  | "startQuote"
  | "endQuote"
  | "overlay1"
  | "overlay2"
  | "overlay3"
  | "lineLeft"
  | "lineRight"
  | "rxIconLarge"
  | "rxIconSmall"
  | "newBadge"
  | "treatmentPlan"
  | "home"
  | "affordable"
  | "doctorB"
  | "journey"
  | "announce"
  | "overlay4"
  | "overlay5"
  | "overlay6"
  | "overlay7"
  | "overlay8"
  | "overlay9"
  | "paperPlane"

type Icons = { [key in IconName]: React.ReactNode }

export const icons: Icons = {
  acute: <Acute />,
  addYellow: <AddYellow />,
  adjust: <Adjust />,
  arrowLeft: <ArrowLeft />,
  arrowRight: <ArrowRight />,
  arrowDown: <ArrowDown />,
  antiNausea: <Nausea />,
  all: <All />,
  backArrow: <BackArrow />,
  avatar: <Avatar />,
  caret: <Caret />,
  checkMark: <CheckMark />,
  coveLogo: <CoveLogo />,
  cross: <Cross />,
  doctor: <Doctor />,
  error: <Error />,
  logo: <Logo />,
  preventative: <Prevent />,
  supplement: <Supplement />,
  pill: <Pill />,
  stethoscope: <Stethoscope />,
  hamburgerMenu: <HamburgerMenu />,
  orderConsult: <OrderConsult />,
  orderSupport: <OrderSupport />,
  orderPill: <OrderPill />,
  orderDrug: <OrderDrug />,
  coveChair: <CoveChair />,
  message: <Message />,
  plus: <Plus />,
  needsRx: <NeedsRx />,
  migraineTracker: <MigraineTracker />,
  coveChairTransparent: <CoveChairTransparent />,
  instagram: <Instagram />,
  facebook: <Facebook />,
  twitter: <Twitter />,
  linkedin: <Linkedin />,
  affordableCoin: <AffordableCoin />,
  doctorStethescope: <DoctorStethescope />,
  shippingTruck: <ShippingTruck />,
  chooseFinger: <ChooseFinger />,
  consultationPencil: <ConsultationPencil />,
  deliveryHouse: <DeliveryHouse />,
  dosageDropper: <DosageDropper />,
  formPill: <FormPill />,
  howToTakeFace: <HowToTakeFace />,
  nameMolecule: <NameMolecule />,
  servingsBottle: <ServingsBottle />,
  typeMill: <TypeMill />,
  reviewsChat: <ReviewsChat />,
  frequency: <FrequencyIcon />,
  renewalCheckmark: <RenewalCheckmark />,
  star: <Star />,
  previous: <Previous />,
  next: <Next />,
  search: <Search />,
  approved: <Approved />,
  matched: <Matched />,
  drAccess: <AccessDr />,
  treatment: <Treatment />,
  tracker: <Tracker />,
  startQuote: <StartQuote />,
  endQuote: <EndQuote />,
  overlay1: <Overlay1 />,
  overlay2: <Overlay2 />,
  overlay3: <Overlay3 />,
  lineLeft: <LineLeft />,
  lineRight: <LineRight />,
  rxIconLarge: <RxIconLarge />,
  rxIconSmall: <RxIconSmall />,
  newBadge: <NewBadge />,
  treatmentPlan: <TreatmentPlan />,
  affordable: <Affordable />,
  doctorB: <DoctorB />,
  home: <Home />,
  journey: <Journey />,
  announce: <Announce />,
  overlay4: <Overlay4 />,
  overlay5: <Overlay5 />,
  overlay6: <Overlay6 />,
  overlay7: <Overlay7 />,
  overlay8: <Overlay8 />,
  overlay9: <Overlay9 />,
  paperPlane: <PaperPlane />
}

export type IconProps = {
  className?: string
  name: IconName
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
} & BoxProps

const Icon: React.FC<IconProps> = ({ name, ...props }) => (
  <Flex alignItems="center" {...props}>
    {icons[name]}
  </Flex>
)

export default Icon
